import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const financialHardshipIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2V22M12 2C10.3431 2 9 3.34315 9 5C9 6.65685 10.3431 8 12 8C13.6569 8 15 9.34315 15 11C15 12.6569 13.6569 14 12 14M12 2C13.6569 2 15 3.34315 15 5M12 22C10.3431 22 9 20.6569 9 19C9 17.3431 10.3431 16 12 16C13.6569 16 15 14.6569 15 13M12 22C13.6569 22 15 20.6569 15 19" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
